import { memo } from 'react';

import EventTimestamp from '@/pages/Timeline/components/EventTimestamp';
import { Props } from '@/pages/Timeline/components/TimestampAndActor/types';

const TimestampAndActor = ({ actor, timestamp }: Props) => {
  return (
    <div className="flex justify-between text-sm text-gray-600 px-2 -mt-1.5">
      <div>{timestamp && <EventTimestamp time={timestamp} />}</div>

      <div>{actor?.display_name}</div>
    </div>
  );
};

export default memo(TimestampAndActor);
